export enum PurchaseOrderStatus {
	Awaiting = 'awaiting',
	Pending = 'pending',
	Accepted = 'accepted',
	Rejected = 'rejected',
	Expired = 'expired',
}